import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function EvTekstiliPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const products = [
    {
      id: 1,
      name: 'Bella Yatak & Baza',
      description: 'Bella\'nın konforlu uyku için kaliteli yatak ve baza setleri',
      image: 'https://public.readdy.ai/ai/img_res/82dceaf6b2d656f513e56092d7504e5c.jpg',
      features: ['Ortopedik destek', 'Kaliteli kumaş', 'Uzun ömürlü'],
      brand: 'Bella'
    },
    {
      id: 2,
      name: 'Taç - Duvar Kağıdı',
      description: 'Taç\'ın duvarlarınıza hayat veren modern ve klasik desenleri',
      image: 'https://readdy.ai/api/search-image?query=Tac%20brand%20elegant%20wallpaper%20with%20sophisticated%20pattern%20in%20neutral%20tones%20displayed%20on%20modern%20interior%20wall%20clean%20minimalist%20room%20showcasing%20texture%20and%20design%20quality%20professional%20product%20photography&width=600&height=700&seq=tac1&orientation=portrait',
      features: ['Kolay uygulama', 'Silinebilir', 'Geniş desen seçeneği'],
      brand: 'Taç'
    },
    {
      id: 3,
      name: 'Taç - Nevresim Takımları',
      description: 'Taç\'ın yumuşak ve kaliteli kumaşlardan nevresim setleri',
      image: 'https://readdy.ai/api/search-image?query=Tac%20brand%20premium%20bedding%20set%20with%20elegant%20duvet%20cover%20and%20pillowcases%20in%20soft%20neutral%20tones%20displayed%20on%20modern%20bed%20clean%20white%20background%20showcasing%20fabric%20quality%20and%20design%20professional%20product%20photography&width=600&height=700&seq=tac2&orientation=portrait',
      features: ['Pamuklu kumaş', 'Renkli seçenekler', 'Kolay bakım'],
      brand: 'Taç'
    },
    {
      id: 4,
      name: 'Bella - Yastık & Yorgan',
      description: 'Bella\'nın konforlu uyku için kaliteli yastık ve yorgan koleksiyonu',
      image: 'https://readdy.ai/api/search-image?query=Bella%20brand%20fluffy%20premium%20pillows%20and%20comforter%20in%20white%20and%20neutral%20tones%20displayed%20on%20elegant%20bed%20clean%20background%20showcasing%20softness%20and%20quality%20professional%20product%20photography&width=600&height=700&seq=bella2&orientation=portrait',
      features: ['Hipoalerjenik', 'Nefes alır', 'Yıkanabilir'],
      brand: 'Bella'
    },
    {
      id: 5,
      name: 'Taç - Paspas & Kilim',
      description: 'Taç\'ın kapı önü ve koridor için şık paspasları',
      image: 'https://readdy.ai/api/search-image?query=Tac%20brand%20modern%20decorative%20doormat%20and%20runner%20rug%20with%20elegant%20pattern%20in%20neutral%20tones%20displayed%20in%20clean%20minimalist%20interior%20showcasing%20design%20and%20quality%20professional%20product%20photography&width=600&height=700&seq=tac3&orientation=portrait',
      features: ['Dayanıklı', 'Kaymaz taban', 'Kolay temizlik'],
      brand: 'Taç'
    },
    {
      id: 6,
      name: 'Taç - Masa Örtüsü',
      description: 'Taç\'ın sofranıza zarafet katan masa örtüleri',
      image: 'https://readdy.ai/api/search-image?query=Tac%20brand%20elegant%20tablecloth%20with%20sophisticated%20pattern%20in%20neutral%20tones%20displayed%20on%20dining%20table%20clean%20white%20background%20showcasing%20fabric%20quality%20and%20design%20professional%20product%20photography&width=600&height=700&seq=tac4&orientation=portrait',
      features: ['Leke tutmaz', 'Kolay ütülenir', 'Çeşitli boyutlar'],
      brand: 'Taç'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white shadow-sm'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center">
              <img src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/2f42915d313b6b9ad9e1e568a266df73.png" alt="Üçoklar Perde" className="h-16 w-auto" />
            </Link>
            
            <div className="hidden lg:flex items-center space-x-8">
              <Link to="/" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Ana Sayfa</Link>
              <Link to="/urunler" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Ürünler</Link>
              <Link to="/hali" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Halı Satışı</Link>
              <Link to="/ev-tekstili" className="text-sm font-medium text-amber-600 transition-colors whitespace-nowrap">Ev Tekstili</Link>
              <Link to="/hakkimizda" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">Hakkımızda</Link>
              <Link to="/iletisim" className="text-sm font-medium text-gray-900 hover:text-amber-600 transition-colors whitespace-nowrap">İletişim</Link>
            </div>

            <Link to="/iletisim" className="hidden lg:block bg-amber-700 hover:bg-amber-800 text-white px-6 py-2.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
              Teklif Al
            </Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-indigo-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-6xl md:text-7xl font-bold text-gray-900 mb-6">Ev Tekstili</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Evinizin her köşesine konfor ve zarafet katan ev tekstili ürünlerimizle tanışın. Yatak, baza, duvar kağıdı ve daha fazlası.
            </p>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
            {products.map((product) => (
              <div 
                key={product.id}
                className="group cursor-pointer"
              >
                <div className="bg-gray-50 rounded-3xl overflow-hidden transition-all hover:shadow-2xl hover:scale-105">
                  <div className="w-full h-96 relative">
                    <img 
                      src={product.image} 
                      alt={product.name} 
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full">
                      <span className="text-sm font-bold text-indigo-700">{product.brand}</span>
                    </div>
                  </div>
                  <div className="p-8">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">{product.name}</h3>
                    <p className="text-gray-600 mb-6 leading-relaxed">{product.description}</p>
                    <div className="space-y-2">
                      {product.features.map((feature, index) => (
                        <div key={index} className="flex items-center gap-2">
                          <i className="ri-check-line text-indigo-600"></i>
                          <span className="text-sm text-gray-700">{feature}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-24 bg-indigo-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-5xl font-bold text-gray-900 mb-6">Evinize Konfor Katın</h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Ev tekstili ürünlerimiz, evinizin her köşesine konfor ve zarafet katar. Yatak odanızdan salonunuza, mutfağınızdan banyonuza kadar her alanda kullanabileceğiniz kaliteli ürünler sunuyoruz.
              </p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Kaliteli kumaşlar, modern tasarımlar ve uygun fiyatlarla evinizi yenileyin. Uzman ekibimiz size en uygun ürünleri seçmenizde yardımcı olur.
              </p>
              <Link to="/iletisim" className="inline-block bg-amber-700 hover:bg-amber-800 text-white px-8 py-4 rounded-full text-lg font-medium transition-all hover:scale-105 whitespace-nowrap cursor-pointer">
                Teklif Al →
              </Link>
            </div>
            <div className="w-full h-96 rounded-3xl overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=cozy%20modern%20bedroom%20interior%20with%20elegant%20textiles%20including%20bedding%20curtains%20and%20decorative%20pillows%20in%20neutral%20tones%20soft%20natural%20lighting%20clean%20minimalist%20design%20showcasing%20home%20textile%20products%20professional%20photography&width=800&height=600&seq=evtekstil1&orientation=landscape" 
                alt="Ev Tekstili" 
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-5xl font-bold text-gray-900 mb-6">Mağazamızı Ziyaret Edin</h2>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Ev tekstili ürünlerimizi yakından görmek için showroomumuza bekleriz. Ürünlerimizi dokunarak ve görerek seçin.
          </p>
          <Link to="/iletisim" className="inline-block bg-amber-700 hover:bg-amber-800 text-white px-8 py-4 rounded-full text-lg font-medium transition-all hover:scale-105 whitespace-nowrap cursor-pointer">
            İletişime Geç →
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-teal-700 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <svg className="w-full h-full" viewBox="0 0 1200 400">
            <path d="M0,200 Q300,100 600,200 T1200,200" stroke="currentColor" strokeWidth="1" fill="none"/>
            <path d="M0,220 Q300,120 600,220 T1200,220" stroke="currentColor" strokeWidth="1" fill="none"/>
          </svg>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
            <div className="lg:col-span-2">
              <img src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/2f42915d313b6b9ad9e1e568a266df73.png" alt="Üçoklar Perde" className="h-36 mb-6" />
              <p className="text-teal-100 mb-6 leading-relaxed">
                30 yıllık tecrübemizle evinize zarafet katıyoruz. Kaliteli ürünler ve profesyonel hizmet anlayışıyla yanınızdayız.
              </p>
              <div className="flex gap-4">
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-youtube-fill text-xl"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Ürünler</h4>
              <ul className="space-y-3">
                <li><Link to="/urunler/plise-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Plise Perde</Link></li>
                <li><Link to="/urunler/jaluzi-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Jaluzi Perde</Link></li>
                <li><Link to="/urunler/tul-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Tül Perde</Link></li>
                <li><Link to="/urunler/fon-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Fon Perde</Link></li>
                <li><Link to="/urunler/zebra-perde" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Zebra Perde</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Ev Tekstili</h4>
              <ul className="space-y-3">
                <li><Link to="/hali" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Halı Satışı</Link></li>
                <li><Link to="/urunler/yatak-baza" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Yatak & Baza</Link></li>
                <li><Link to="/ev-tekstili" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Duvar Kağıdı</Link></li>
                <li><Link to="/ev-tekstili" className="text-teal-100 hover:text-white transition-colors cursor-pointer">Ev Tekstili</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">İletişim</h4>
              <ul className="space-y-3">
                <li className="text-teal-100 text-sm leading-relaxed">
                  <i className="ri-map-pin-line mr-2"></i>
                  Kemalpaşa, Cumhuriyet Cd. No:52, 06780 Elmadağ/Ankara
                </li>
                <li>
                  <a href="tel:+905336178275" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                    <i className="ri-phone-line mr-2"></i>
                    0533 617 82 75
                  </a>
                </li>
                <li>
                  <a href="mailto:info@ucoklarperde.com" className="text-teal-100 hover:text-white transition-colors text-sm cursor-pointer">
                    <i className="ri-mail-line mr-2"></i>
                    info@ucoklarperde.com
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-teal-600 pt-8">
            <p className="text-teal-100 text-sm text-center">© 2025 Üçoklar Perde. Tüm hakları saklıdır.</p>
          </div>
        </div>
      </footer>

      {/* WhatsApp Button */}
      <a 
        href="https://wa.me/905336178275" 
        target="_blank" 
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 z-50 w-16 h-16 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-2xl transition-all hover:scale-110 cursor-pointer group"
      >
        <i className="ri-whatsapp-line text-3xl text-white"></i>
        <span className="absolute right-20 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          WhatsApp ile İletişim
        </span>
      </a>
    </div>
  );
}